module.exports = __webpack_public_path__ + "static/media/Gena Erwin Headshot.913da90f.jpeg";